export const checkIsUpgradeSubscription = (subscriptionMaxMachine: number) => {
    // Check if subscription has more than 1 machine => Prevent redeeming offer
    // Just allow 1 machine to redeem offer
    return subscriptionMaxMachine > 1
};
